export const validateObjectId = (value?: string) => {
  if (!value) {
    return true;
  }

  const objectIdRegex = /^[0-9a-fA-F]{24}$/;

  return objectIdRegex.test(value);
};
